import { lazy } from "react";
/**
 * React.lazy plus preload(), which starts the same import() ahead of render.
 * Both share one cached promise. A rejected promise is dropped so a failed
 * preload does not make the route fail later; the next call retries.
 */
export function lazyWithPreload(factory) {
    let promise;
    const preload = () => {
        if (!promise) {
            promise = factory().catch((error) => {
                promise = undefined;
                throw error;
            });
        }
        return promise;
    };
    return Object.assign(lazy(preload), { preload });
}
